export interface SelectOption {
    value: string;
    label: string;
}

export type SelectInternalValue = null | {
    label: string;
    value: string;
};

export const transformSelectSetOptionsVisibility = (
    { options, isVisible }: { options: string[]; isVisible: boolean },
    lookupValues?: SelectOption[]
) => lookupValues?.filter(({ value }) => (isVisible ? options.includes(value) : !options.includes(value)));

export const transformSelectGetOptionsVisibility = (
    { options, isVisible }: { options: string[]; isVisible: boolean },
    lookupValues?: SelectOption[]
) => ({
    isVisible,
    options: options.filter((option) => lookupValues?.some((val) => val.value === option)),
});

export const selectSetValueTransformer = (optionId: string | null, options: SelectOption[]) => {
    if (optionId === null) {
        return null;
    }
    const option = options?.find((item) => item.value === optionId);
    return option;
};

export const selectGetValueTransformer = (value: SelectInternalValue): { id: string; value: string } | null => {
    if (!value) {
        return null;
    }

    const { label, value: id } = value;

    return { id, value: label };
};

export const modifySelectValueToBasic = (selectedOption: SelectOption | null) => {
    if (selectedOption === null) {
        return null;
    }
    return selectedOption?.value;
};
